/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var lang_1 = require('../../facade/lang');
var exceptions_1 = require('../../facade/exceptions');
var hammer_common_1 = require('./hammer_common');
exports.HAMMER_GESTURE_CONFIG = new core_1.OpaqueToken("HammerGestureConfig");
var HammerGestureConfig = (function() {
  function HammerGestureConfig() {
    this.events = [];
    this.overrides = {};
  }
  HammerGestureConfig.prototype.buildHammer = function(element) {
    var mc = new Hammer(element);
    mc.get('pinch').set({enable: true});
    mc.get('rotate').set({enable: true});
    for (var eventName in this.overrides) {
      mc.get(eventName).set(this.overrides[eventName]);
    }
    return mc;
  };
  HammerGestureConfig.decorators = [{type: core_1.Injectable}];
  return HammerGestureConfig;
}());
exports.HammerGestureConfig = HammerGestureConfig;
var HammerGesturesPlugin = (function(_super) {
  __extends(HammerGesturesPlugin, _super);
  function HammerGesturesPlugin(_config) {
    _super.call(this);
    this._config = _config;
  }
  HammerGesturesPlugin.prototype.supports = function(eventName) {
    if (!_super.prototype.supports.call(this, eventName) && !this.isCustomEvent(eventName))
      return false;
    if (!lang_1.isPresent(window['Hammer'])) {
      throw new exceptions_1.BaseException("Hammer.js is not loaded, can not bind " + eventName + " event");
    }
    return true;
  };
  HammerGesturesPlugin.prototype.addEventListener = function(element, eventName, handler) {
    var _this = this;
    var zone = this.manager.getZone();
    eventName = eventName.toLowerCase();
    return zone.runOutsideAngular(function() {
      var mc = _this._config.buildHammer(element);
      var callback = function(eventObj) {
        zone.runGuarded(function() {
          handler(eventObj);
        });
      };
      mc.on(eventName, callback);
      return function() {
        mc.off(eventName, callback);
      };
    });
  };
  HammerGesturesPlugin.prototype.isCustomEvent = function(eventName) {
    return this._config.events.indexOf(eventName) > -1;
  };
  HammerGesturesPlugin.decorators = [{type: core_1.Injectable}];
  HammerGesturesPlugin.ctorParameters = [{
    type: HammerGestureConfig,
    decorators: [{
      type: core_1.Inject,
      args: [exports.HAMMER_GESTURE_CONFIG]
    }]
  }];
  return HammerGesturesPlugin;
}(hammer_common_1.HammerGesturesPluginCommon));
exports.HammerGesturesPlugin = HammerGesturesPlugin;
